import { boot } from 'quasar/wrappers';
import { createStore } from 'vuex';

import brandVoice from 'boot/vuex/brandVoice';
import socialMediaPlanner from './vuex/socialMediaPlanner/socialMediaPlanner';
import aiWriter from './vuex/aiWriter/aiWriter';
import copy from './vuex/copy';
import cloudFilePicker from './vuex/cloudFilePicker';
import aiImages from './vuex/aiImages';
import bookGenerator from './vuex/bookGenerator/bookGenerator';
import documents from './vuex/documents';
import dashboard from './vuex/dashboard';
import viewpoint from './vuex/viewpoint';
import emailChain from './vuex/emailChain';
import autoresponders from './vuex/autoresponders';

const store = createStore({
  modules: {
    socialMediaPlanner,
    aiWriter,
    brandVoice,
    copy,
    cloudFilePicker,
    aiImages,
    bookGenerator,
    documents,
    dashboard,
    viewpoint,
    emailChain,
    autoresponders,
  },
});

export default boot(({ app }) => {
  app.use(store);
});
